import { render, staticRenderFns } from "./products-breadcrumb.vue?vue&type=template&id=0e8b8c84&scoped=true&"
import script from "./products-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./products-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./products-breadcrumb.vue?vue&type=style&index=0&id=0e8b8c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b8c84",
  null
  
)

export default component.exports